(function($) {
  $(document).ready(function() {
    //Validation

    var errors = true;

    $('#profile-form').validate({
      errorElement: 'span',
      rules: {
        email: {
          email: true,
        },
        password: {
          minlength: 8,
          // pwcheck: true,
        },
        'home-phone': {
          required: true,
        },
        'work-phone': {
          required: true,
        },
        'city-directory': {
          required: true,
        },
        'home-address': {
          required: true,
        },
        'home-city': {
          required: true,
        },
        'home-province': {
          required: true,
        },
        'home-postal-code': {
          required: true,
        },
      },
    });

    $('.form-profile-submit').click(function(event) {
      event.preventDefault();
      var validation = $('#profile-form').valid();

      if (!validation) {
        $('.alert-message-success').hide();
        $('.alert-message').show();
        $(window).scrollTop(0);
      } else {
        $('.alert-message').hide();
      }

      if (validation) {
        var formData = $('#profile-form').serialize();

        $('.waiting').addClass('show');

        $.ajax({
          url: ajax_object.ajaxurl,
          type: 'POST',
          data: {
            action: 'ajax_action_profile_validation',
            form: formData,
          },
          success: function(response) {
            ajaxData(response);
            $('.alert-message').hide();
          },
          error: function(response) {
            errors = true;
            console.log('Error:');
            console.log(response);
            $('.waiting').removeClass('show');
            return false;
          },
        });

        function ajaxData(response) {
          var response = $.parseJSON(response);

          $('.alert-message-success').hide();

          if (response.email) {
            $('.alert-message-email').show();
            $('.waiting').removeClass('show');
            $(window).scrollTop(0);
          } else {
            $('.alert-message').hide();
            $('.waiting').addClass('show');
            errors = false;
            if (response.sameemail) {
              $('#email').val('');
            }
            $('#profile-form').submit();
          }
        }
      }
    });

    if ($('.woocommerce').hasClass('my-profile')) {
      checkDeleteButton();
    }

    function checkDeleteButton() {
      var numItemsAddress = $('div[id^="another-address-"]').length;

      if (numItemsAddress > 1) {
        $('#remove-address').removeClass('d-none');
      } else {
        $('#remove-address').addClass('d-none');
      }
    }
  });
})(jQuery);
